/*
 * PAWS & PEARLS — LILLA'S FIVE MINI ZEBRA FOLLOWERS — V1.2
 * 27 October 2026 | MAGICAL MUSE WORLD unpublished duplicate theme ONLY.
 *
 * FIX for V1.1: The five zebras FOLLOW THE EXISTING LILLA ACTOR DIRECTLY.
 * No separate independent trajectory. Their position, proportional size and
 * disappearance are based on the actual working Lilla/zebra controller.
 * This changes no other animation, image, world geometry or soundtrack.
 *
 * PRECONDITION: Keep existing V1.1 Liquid block containing the 16 frame URLs.
 * Installation: upload this new JS file to Assets, then CHANGE ONLY the existing
 * <script src="...pp-muse-mini-zebra-entourage-v1-1.js..."> reference to V1.2.
 * NEVER load both V1.1 and V1.2.
 */
(function () {
  'use strict';
  var VERSION = '1.2-follow-live-lilla';
  var SKY_ID = 'pp-muse-secret-sky';
  var LILLA_ID = 'pp-muse-lilla-zebra-v1';
  var STAGE_ID = 'pp-muse-balloon-stage';
  var LAYER_ID = 'pp-muse-mini-zebra-entourage-v1-2';
  var STYLE_ID = LAYER_ID + '-style';
  var NS = 'ppMuseMiniZebraEntourageV1_2';
  var CONFIG = window.PP_LILLA_MINI_ZEBRA_SQUADRON_CONFIG || {};
  var FRAME_MS = 120;
  var MAX_RUN_SECONDS = 58; // Last flight-position check; Lilla normally hides by 54s.
  var instance = null, run = null, rafId = 0;

  function clamp(min, x, max) { return Math.min(max, Math.max(min, x)); }
  function reduced() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }
  function desktop() { return (window.innerWidth || 1024) >= 768; }
  function urls() {
    var list = CONFIG.frameUrls;
    if (!Array.isArray(list) || list.length !== 16) return null;
    for (var i = 0; i < list.length; i++) {
      if (typeof list[i] !== 'string' || !/^(https?:\/\/|\/)/.test(list[i])) return null;
    }
    return list;
  }
  function findLilla() {
    return document.querySelector('#' + LILLA_ID + ' .pp-lilla-zebra-actor');
  }
  function style() {
    if (document.getElementById(STYLE_ID)) return;
    var el = document.createElement('style');
    el.id = STYLE_ID;
    el.textContent = [
      'html.pp-muse-secret-sky-page #' + SKY_ID + ' #' + LAYER_ID + '{position:absolute!important;inset:0!important;z-index:2!important;overflow:hidden!important;pointer-events:none!important;user-select:none!important;}',
      'html.pp-muse-secret-sky-page #' + LAYER_ID + ' .pp-mini-zebra-escort{position:absolute!important;left:0;top:0;display:none;pointer-events:none!important;user-select:none!important;transform-origin:center center;will-change:left,top,transform,width;}',
      'html.pp-muse-secret-sky-page #' + LAYER_ID + ' .pp-mini-zebra-escort img{display:block!important;width:100%!important;height:auto!important;max-width:none!important;opacity:1!important;object-fit:contain!important;pointer-events:none!important;user-select:none!important;-webkit-user-drag:none;}',
      '@media(max-width:767px){html.pp-muse-secret-sky-page #' + LAYER_ID + '{display:none!important;}}',
      '@media(prefers-reduced-motion:reduce){html.pp-muse-secret-sky-page #' + LAYER_ID + '{display:none!important;}}'
    ].join('');
    document.head.appendChild(el);
  }
  function hide() { if (instance) instance.actor.style.display = 'none'; }
  function stop() {
    if (rafId) cancelAnimationFrame(rafId);
    rafId = 0;
    run = null;
    hide();
  }
  function setup() {
    if (!document.documentElement.classList.contains('pp-muse-secret-sky-page')) return null;
    var sky = document.getElementById(SKY_ID);
    var wrapper = document.querySelector('.page-wrapper');
    if (!sky || !wrapper || !wrapper.contains(sky)) return null;
    if (instance && instance.sky === sky && instance.layer.isConnected) return instance;
    var frameUrls = urls();
    if (!frameUrls) {
      console.warn('[P&P Mini Zebra V1.2] 16 WebP URLs not available; scene unchanged.');
      return null;
    }
    stop();
    if (instance && instance.layer) instance.layer.remove();
    style();
    var layer = document.createElement('div');
    layer.id = LAYER_ID;
    layer.setAttribute('aria-hidden', 'true');
    var actor = document.createElement('div');
    actor.className = 'pp-mini-zebra-escort';
    var img = document.createElement('img');
    img.alt = '';
    img.draggable = false;
    img.decoding = 'async';
    img.loading = 'eager';
    actor.appendChild(img);
    layer.appendChild(actor);
    sky.appendChild(layer);
    var frames = frameUrls.map(function (url) {
      var frame = new Image();
      frame.decoding = 'async';
      frame.src = url;
      return frame;
    });
    instance = {sky:sky,layer:layer,actor:actor,img:img,frames:frames};
    return instance;
  }
  function start() {
    if (reduced() || !desktop()) return;
    var env = setup();
    if (!env) return;
    stop();
    run = {env:env,startedAt:performance.now(),lastFrame:-1,lastTime:0,
           position:null,phase:'waiting-for-lilla',seconds:0};
    rafId = requestAnimationFrame(tick);
  }
  function tick(now) {
    rafId = 0;
    var r = run;
    if (!r || !r.env.layer.isConnected) return;
    var seconds = (now - r.startedAt) / 1000;
    r.seconds = seconds;
    if (seconds >= MAX_RUN_SECONDS || reduced() || !desktop()) { stop(); return; }

    // Lilla's own code controls arrival, bob, rendezvous, departure and visibility.
    // Reading the LIVE actor avoids independently replaying an out-of-sync path.
    var lilla = findLilla();
    var visible = lilla && lilla.isConnected &&
      parseFloat(lilla.style.opacity || '0') >= 0.12 &&
      window.getComputedStyle(lilla).display !== 'none';
    if (!visible) {
      hide();
      r.phase = 'waiting-for-lilla-or-finished';
      r.position = null; // rejoin directly if Lilla reappears on a future click
      rafId = requestAnimationFrame(tick);
      return;
    }

    // Both actor layers cover the same full #pp-muse-secret-sky coordinate system.
    var lx = parseFloat(lilla.style.left), ly = parseFloat(lilla.style.top);
    var lw = parseFloat(lilla.style.width);
    if (!isFinite(lx) || !isFinite(ly) || !isFinite(lw) || lw <= 0) {
      hide();
      rafId = requestAnimationFrame(tick);
      return;
    }
    var skyW = r.env.sky.clientWidth || r.env.sky.getBoundingClientRect().width;
    var skyH = r.env.sky.clientHeight || r.env.sky.getBoundingClientRect().height;
    if (!skyW || !skyH) { hide(); rafId = requestAnimationFrame(tick); return; }

    // Five tiny zebras together are less visually prominent than Lilla's mount.
    var groupW = clamp(62, lw * 0.93, 180);
    // A continuous offset keeps the escort just behind and slightly below Lilla.
    // During the up-left departure, they travel WITH Lilla, rather than returning
    // independently to the terrace. Keep safely left of the hippo rendezvous.
    var gapPx = clamp(14, skyW * 0.015, 25);
    var xOffsetPercent = ((lw + groupW) / 2 + gapPx) / skyW * 100;
    var yOffsetPercent = (lw * 0.22 + 13) / skyH * 100;
    var targetX = lx - xOffsetPercent;
    var targetY = ly + yOffsetPercent;

    // Mild following inertia: gently track Lilla; no unrelated waypoints.
    if (!r.position) r.position = {x:targetX,y:targetY};
    var dt = r.lastTime ? Math.max(0, now-r.lastTime) : 16;
    // Recover immediately after Safari background-tab throttling or big jumps.
    if (dt > 300) {
      r.position.x = targetX;
      r.position.y = targetY;
    } else {
      var easeFollow = 1 - Math.exp(-dt / 320);
      r.position.x += (targetX - r.position.x) * easeFollow;
      r.position.y += (targetY - r.position.y) * easeFollow;
    }
    r.lastTime = now;

    var index = Math.floor(seconds * 1000 / FRAME_MS) % 16;
    if (index !== r.lastFrame) {
      var pic = r.env.frames[index];
      if (pic && pic.complete && pic.naturalWidth > 0) {
        r.env.img.src = pic.src;
        r.lastFrame = index;
      }
    }
    if (r.lastFrame < 0) { hide(); rafId = requestAnimationFrame(tick); return; }
    var bob = 1.8 * Math.sin(seconds * Math.PI * 2 / 3.1);
    r.env.actor.style.left = r.position.x.toFixed(3) + '%';
    r.env.actor.style.top = r.position.y.toFixed(3) + '%';
    r.env.actor.style.width = groupW.toFixed(1) + 'px';
    r.env.actor.style.transform = 'translate(-50%,-50%) translate3d(0,' + bob.toFixed(2) + 'px,0)';
    r.env.actor.style.display = 'block';
    r.phase = 'following-lilla';
    rafId = requestAnimationFrame(tick);
  }
  function clickHandler(event) {
    var node = event.target;
    var correctBalloon = node && node.closest &&
      node.closest('#' + STAGE_ID + ' .pp-balloon, .pp-muse-flight-overlay.pp-balloon');
    if (correctBalloon) start();
  }
  function initialize() { setup(); }
  window[NS] = {
    version:VERSION,
    getStatus:function () {
      return {
        present:!!(instance && instance.layer && instance.layer.isConnected),
        running:!!run,
        followingLilla:!!(run && run.phase === 'following-lilla'),
        phase:run ? run.phase : 'idle',
        secondsAfterMuseClick:run ? Math.round(run.seconds*10)/10 : null,
        escortCoordinates:run && run.position ? {x:run.position.x,y:run.position.y} : null,
        usesLiveLillaPosition:true,
        groupCount:5,
        sourceFrames:16,
        changesExistingFlight:false
      };
    }
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded',initialize,{once:true});
  } else initialize();
  document.addEventListener('click',clickHandler,false);
  document.addEventListener('shopify:section:load',initialize);
  document.addEventListener('shopify:section:unload',function (event) {
    if (instance && event.target &&
        (event.target === instance.sky || event.target.contains(instance.sky))) {
      stop();
      instance.layer.remove();
      instance = null;
    }
  });
  window.addEventListener('pageshow',initialize);
})();
